/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
import membersWorks from "./functions/membersWorks";
import heroModules from "./functions/heroModules";

// require('./bootstrap');

$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});

/**
 * Include the FrontEnd index.js file
 */

require('./functions/main')

import register from './functions/register'
import share from './functions/share'
import members from './functions/members'
import sections from './functions/sections'
import forms from './functions/forms'
import profile from './functions/profile'
// import gallery from './functions/gallery'

register();
share();
members('members-section', true);
sections();
forms();
profile();
// gallery();
membersWorks();
heroModules();


// WEBPACK FOOTER //
// ./resources/assets/js/app.js